import { ContactsForm, useContactsForm } from '../../ContactsForm';
import {
  CompanySetupTabType,
  CompanySetupTabWrapper,
} from '../CompanySetupTabWrapper';

const isFinalizationMode = true;

type Props = {
  employerId: string;
  isDon: boolean;
};

export const ContactsSetupTab = ({ employerId, isDon }: Props) => {
  const { contactsForm, onSubmit } = useContactsForm(
    employerId,
    isFinalizationMode
  );
  const { formState } = contactsForm;

  return (
    <CompanySetupTabWrapper
      onCancel={() => contactsForm.reset()}
      tab={CompanySetupTabType.CONTACTS}
      employerId={employerId}
      formState={formState}
      onSubmit={onSubmit}
      isDon={isDon}
    >
      <ContactsForm
        isFinalizationMode={isFinalizationMode}
        contactsForm={contactsForm}
        shouldShowOnboardingContacts
        shouldHideMakeAdmin
      />
    </CompanySetupTabWrapper>
  );
};
